import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./motion";
import { SITE } from "../lib/site";
import { useLang } from "../i18n/LanguageContext";

// Large dark-green conversion band — reused across pages.
export const CtaBand = ({
    headline = "Not sure where to begin?",
    text = "Tell us about your healthcare needs. Our team will help you understand the next steps.",
}) => {
    const { t } = useLang();
    return (
    <section className="container-site pb-16 sm:pb-24">
        <Reveal>
            <div
                data-testid="cta-band"
                className="relative overflow-hidden bg-forest text-ivory rounded-2xl px-6 sm:px-12 lg:px-20 py-16 sm:py-24"
            >
                <div
                    aria-hidden="true"
                    className="pointer-events-none absolute -top-40 -right-40 w-[560px] h-[560px] rounded-full bg-pine/50 blur-3xl"
                />
                <div
                    aria-hidden="true"
                    className="pointer-events-none absolute -bottom-48 -left-32 w-[460px] h-[460px] rounded-full bg-natural/15 blur-3xl"
                />
                <div className="relative max-w-2xl">
                    <h2 className="font-serif font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                        {headline}
                    </h2>
                    <p className="mt-6 text-base sm:text-lg leading-relaxed text-ivory/70 max-w-xl">
                        {text}
                    </p>
                    <div className="mt-10 flex flex-col sm:flex-row gap-4">
                        <Link
                            to="/get-a-medical-opinion"
                            data-testid="cta-band-opinion"
                            className="btn-ivory group"
                        >
                            {t("common.get_medical_opinion", "Get a Medical Opinion")}
                            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                        </Link>
                        <a
                            href={SITE.whatsappUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="cta-band-whatsapp"
                            className="btn-outline-light"
                        >
                            <MessageCircle className="w-4 h-4" />
                            {t("common.chat_whatsapp", "Chat on WhatsApp")}
                        </a>
                    </div>
                </div>
            </div>
        </Reveal>
    </section>
    );
};
